import React, { useEffect, useState } from 'react'
import Traduction from 'Components/Traduction'
import Select from 'Components/Select'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import User from 'EurestoClass/User'
import Utils from 'EurestoFonction/Utils'


export default React.memo(props => {

  const [object, setObject] = useState(props.object || {})
  const [key, setKey] = useState(Utils.getRandomNumber())
  const [disabled, setDisabled] = useState(props.disabled || false)

  const onChange = (data, name) => {
    const obj = {
      ...(object || {}),
      [name]: data
    }
    setObject(obj)
    props.onChange && props.onChange(EurestoClone(obj))
  }

  useEffect(() => {
    if (!_.isEqual(props.object, object)) {
      setKey(Utils.getRandomNumber())
      setObject(props.object || {})
    }
  }, [props.object])

  return (
    <Grid key={key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
      justify="flex-start"
      alignItems="stretch">
      <Traduction
        autoFocus={!disabled}
        title={EurestoI18n.t('commun:Nom')}
        onChange={onChange}
        name={'libelle'}
        disabled={disabled}
        data={object.libelle !== undefined ? object.libelle : []}
        type={Constants.typeSaisie.SaisieLibre}
      />
      <Select
        title={EurestoI18n.t('commun:Entité')}
        name="type"
        disabled={disabled}
        multiple={true}
        options={Constants.usefullObjectStatic[Constants.module.CRM + '-' + Constants.donnee.info_tiers].entite.filter(o => o.condition ? o.condition() : true).map(o => ({
          label: o.libelle,
          value: o.id
        }))}
        value={object.type && (typeof object.type === 'string' && JSON.parse(object.type) || object.type) || []}
        onChange={onChange} />

      {User.TypeAccess.get(Constants.access.EURESTO) && <Select
        title={EurestoI18n.t('commun:Accessible pour...')}
        name="actif"
        disabled={disabled}
        options={[
          {
            label: EurestoI18n.t('commun:Tous'),
            value: 1
          },
          {
            label: EurestoI18n.t('commun:Seulement Euresto'),
            value: 2
          },
          {
            label: EurestoI18n.t('commun:Tous sauf Euresto'),
            value: 3
          }
        ]}
        value={object.actif !== undefined ? object.actif : 1} onChange={onChange} />}
    </Grid>
  )
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/CRM/MotifArchivage/form.js